import bindAllMethods from '../../../utils/bindAllMethods';
import * as T from './types';

export default class NavigationElement implements T.INavigationElement {
  private _state: T.NavigationElementStateType = {
    isVisible: false
  };
  private _listeners: Map<
    T.NavigationElementCallbackType<void>,
    T.NavigationElementCallbackType<void>
  > = new Map();

  constructor() {
    bindAllMethods(this);
  }

  private _notifyListeners() {
    this._listeners.forEach((callback) => {
      callback(this._state);
    });
  }

  setState(newState: T.NavigationElementStateType): void {
    if (typeof newState?.isVisible !== 'boolean') {
      console.error(
        'NavigationElement.setState: isVisible must be a boolean value'
      );
      return;
    }
    const isSameVisibility = this._state.isVisible === newState?.isVisible;
    const isSameProperties =
      JSON.stringify(this._state.properties ?? undefined) ===
      JSON.stringify(newState?.properties ?? undefined);

    if (isSameVisibility && isSameProperties) return;
    this._state = newState;
    this._notifyListeners();
  }
  getState(): Readonly<T.NavigationElementStateType> {
    return this._state;
  }
  listenStateChange(
    callback: T.NavigationElementCallbackType<void>
  ): T.NavigationElementListenerType {
    const wrappedCallback = (value: T.NavigationElementStateType) => {
      try {
        callback(value);
      } catch (error) {
        console.error('Error in navigation element listener:', error);
      }
    };
    this._listeners.set(callback, wrappedCallback);
    return {
      remove: () => {
        this._listeners.delete(callback);
      }
    };
  }
  useReactStateListener(React: any): T.NavigationElementStateType {
    const [state, setState] = React.useState(this.getState()) as [
      T.NavigationElementStateType,
      (value: T.NavigationElementStateType) => void
    ];

    React.useEffect(() => {
      try {
        const callback = (value: T.NavigationElementStateType) => {
          setState(value);
        };
        const listener = this.listenStateChange(callback);
        return () => {
          listener.remove();
        };
      } catch (error) {
        console.error('Error in useReactStateListener:', error);
      }
    }, []);

    return state;
  }
}
